export const ButtonDT = {
	button: {
		extend: {
			fullWidth: '100%',
			accent: {
				bgColor: 'var(--p-marketing-carrot)',
				borderColor: 'var(--p-marketing-carrot)',
				textColor: '#ffffff',
				hover: {
					bgColor: '#E83C05',
					borderColor: '#E83C05',
					textColor: '#ffffff',
				},
				active: {
					bgColor: '#DB3905',
					borderColor: '#DB3905',
					textColor: '#ffffff',
				},
			},
		},
		css: ({ dt }) => `
          .p-button__max-width {
              width: ${dt('button.full.width')} !important;
          }
          .p-button-icon-only__max-width.p-button-fluid.p-button-icon-only {
              width: 100%;
          }

          .p-button__no-padding {
              padding: 0;
          }

          .p-button__warn {
            color: var(--p-marketing-carrot)
          }

          .p-button__no-wrap-text {
              white-space: nowrap;
          }

          .p-button-icon-only-sm {
              min-width: 1.375rem;
              height: 1.375rem;
              padding: var(--p-padding-xs);
          }
          .p-button-icon-only-sm-square {
              width: 1.375rem;
              height: 1.375rem;
              padding: var(--p-padding-xs);
          }
          .p-button-icon-only-sm-h {
              height: 1.375rem;
              padding: .25rem 1rem;
          }

          .p-button-accent {
              color: ${dt('button.accent.textColor')};
              background: ${dt('button.accent.bgColor')};
              border: ${dt('button.accent.borderColor')};
              &:enabled:hover {
                color: ${dt('button.accent.hover.textColor')};
                background: ${dt('button.accent.hover.bgColor')};
                border: ${dt('button.accent.hover.borderColor')};
              }
              &:enabled:active {
                color: ${dt('button.accent.active.textColor')};
                background: ${dt('button.accent.active.bgColor')};
                border: ${dt('button.accent.active.borderColor')};
              }
              &.p-button-outlined {
                  color: ${dt('button.accent.bgColor')};
                  border: ${dt('button.accent.borderColor')};
                  &:enabled:hover {
                      color: ${dt('button.accent.hover.bgColor')};
                      border: ${dt('button.accent.hover.borderColor')};
                  }
                  &:enabled:active {
                      color: ${dt('button.accent.active.bgColor')};
                      border: ${dt('button.accent.active.borderColor')};
                  }
              }

              &.p-button-text {
                  color: ${dt('button.accent.bgColor')};
                  &:enabled:hover {
                      color: ${dt('button.accent.hover.bgColor')};
                  }
                  &:enabled:active {
                      color:  ${dt('button.accent.active.borderColor')};
                  }
              }
          }

          .p-button-like-input {
              color: ${dt('form.field.color')};
              background: ${dt('form.field.background')};
              border-color: ${dt('form.field.border.color')};
              font-size: 1rem;
              .p-button-label {
                  font-weight: normal;
              }
              &:enabled:hover {
                color: ${dt('form.field.hover.color')};
                background: ${dt('form.field.hover.background')};
                border-color: ${dt('form.field.hover.border.color')};
              }
              &:enabled:active {
                color: ${dt('form.field.active.color')};
                background: ${dt('form.field.active.background')};
                border-color: ${dt('form.field.active.border.color')};
              }
          }
        `,
		colorScheme: {
			light: {
				extend: {
					accent: {
						color: '#FFFFFF',
						background: 'var()',
						hover: {
							color: '#FFFFFF',
							background: '#1E1E2C',
							border: { color: '#1E1E2C' },
						},
						active: {
							color: '#FFFFFF',
							background: '#181829',
							border: { color: '#181829' },
						},
						border: {
							color: '#2B2B36',
						},
					},
				},
				primary: {
					color: '#FFFFFF',
					background: '#2B2B36',
					hover: {
						color: '#FFFFFF',
						background: '#1E1E2C',
						border: { color: '#1E1E2C' },
					},
					active: {
						color: '#FFFFFF',
						background: '#181829',
						border: { color: '#181829' },
					},
					border: {
						color: '#2B2B36',
					},
				},
				secondary: {
					color: '#FFFFFF',
					background: '#51515E',
					hover: {
						color: '#FFFFFF',
						background: '#404054',
						border: { color: '#404054' },
					},
					active: {
						color: '#FFFFFF',
						background: '#363650',
						border: { color: '#363650' },
					},
					border: {
						color: '#51515E',
					},
				},
				success: {
					color: '#FFFFFF',
					background: '#22C55E',
					hover: {
						color: '#FFFFFF',
						background: '#16A34A',
						border: { color: '#16A34A' },
					},
					active: {
						color: '#FFFFFF',
						background: '#15803D',
						border: { color: '#15803D' },
					},
					border: {
						color: '#22C55E',
					},
				},
				outlined: {
					primary: {
						color: '#2B2B36',
						border: { color: '#2B2B36' },
					},
					secondary: {
						color: '#51515E',
						border: { color: '#51515E' },
					},
					success: {
						color: '#22C55E',
						border: { color: '#22C55E' },
					},
				},
				text: {
					primary: { color: '#2B2B36' },
					secondary: { color: '#51515E' },
					success: { color: '#22C55E' },
				},
				link: {
					color: '#57449A',
					hover: { color: '#57449A' },
					active: { color: '#57449A' },
				},
			},
			// dark: { }, // TODO
		},
	},
};
